import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css"; // Import default calendar styles

const ShowCalendar = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [highlightedDates, setHighlightedDates] = useState({});
  const [recordDetails, setRecordDetails] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);

  useEffect(() => {
    fetchRecords();
  }, [year, month]);

  const fetchRecords = async () => {
    try {
      const response = await fetch("https://api.wiczka.eu/api/data/", {
        headers: { Authorization: `Token ${localStorage.getItem("token")}` },
      });

      if (!response.ok) throw new Error("Failed to fetch records");

      const data = await response.json();
      const dateMap = {};

      data.forEach((record) => {
        const dateKey = record.data_waznosci;
        dateMap[dateKey] = record;
      });

      setHighlightedDates(dateMap);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  
    // Convert to Warsaw timezone (YYYY-MM-DD)
    const dateStr = date.toLocaleDateString("pl-PL", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).split(".").reverse().join("-"); // Converts DD.MM.YYYY → YYYY-MM-DD
  
    if (highlightedDates[dateStr]) {
      setRecordDetails(highlightedDates[dateStr]);
    } else {
      setRecordDetails(null);
    }
  };

  const getHighlightStyle = (date) => {
    const dateStr = date.toLocaleDateString("pl-PL", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).split(".").reverse().join("-");
  
    if (!highlightedDates[dateStr]) return {}; // No highlight
  
    const todayStr = new Date().toLocaleDateString("pl-PL", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).split(".").reverse().join("-");
  
    if (dateStr === todayStr) {
      return {
        background: `linear-gradient(135deg, var(--brown) 50%, var(--medium-green) 50%)`, // Diagonal split
        color: "white",
      };
    }
  
    return {
      backgroundColor: dateStr < todayStr ? "gray" : "var(--medium-green)", // Gray for past, dark green for future
      color: "white",
    };
  };
  
  

  return (
    <div className="calendar-container">
      <h2>Calendar View</h2>
      <div className="calendar-controls">
      </div>

      <Calendar
        onChange={handleDateChange}
        value={selectedDate}
        tileClassName={({ date }) => {
            const dateStr = date.toLocaleDateString("en-CA"); // Format YYYY-MM-DD
            const todayStr = new Date().toLocaleDateString("en-CA");
          
            if (dateStr === todayStr) return "today-highlight";  
            if (highlightedDates[dateStr]) return "highlighted-date";  
          
            return "";
          }}
          tileContent={({ date }) => {
            const style = getHighlightStyle(date);
            return style ? <div style={style} className="highlight-box"></div> : null;
          }}
          
      />

      {recordDetails && (
        <div className="record-details">
          <h3>Dane dla:</h3> {selectedDate ? selectedDate.toLocaleDateString("en-CA") : "No date selected"}
          <p>
            <strong>Przyrząd pomiarowy:</strong> {recordDetails.przyrzad_pomiarowy}
          </p>
          <p>
            <strong>Lokalizacja:</strong> {recordDetails.miejsce_uzytkowania}
          </p>
        </div>
      )}
    </div>
  );
};

export default ShowCalendar;
